// extracted by mini-css-extract-plugin
export default {"fields":"product-description-modal_fields__q6o9i","actions":"product-description-modal_actions__dC9vk","noSelectInput":"product-description-modal_noSelectInput__bWb07"};